import React from 'react';
import { Button, Col, Form, Input, Modal, Row, Select } from 'antd';
import { useI18n } from '../i18n';

const { Option } = Select;

export default function LeadModal({
  modalType,
  open,
  onCancel,
  onSubmit,
  form,
}) {
  const isCreate = modalType === 'createLead';
  const { t } = useI18n();

  return (
    <Modal
      title={isCreate ? t('Add New Lead/Client') : t('Edit Client')}
      open={open}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="cancel" onClick={onCancel}>{t('Close')}</Button>,
        <Button key="submit" type="primary" onClick={onSubmit}>
          {isCreate ? t('Create') : t('Update')}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={t('Client Name')} name="name" required>
              <Input placeholder={t('Client name')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={t('CVR Number')} name="cvr" required>
              <Input placeholder={t('CVR number')} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={t('Email')} name="email" required>
              <Input placeholder="email@example.com" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={t('Phone')} name="phone" required>
              <Input placeholder="+45 12 34 56 78" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={t('Status')} name="status" required>
              <Select>
                <Option value="Lead/Prospect">{t('Lead/Prospect')}</Option>
                <Option value="Customer">{t('Customer')}</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={t('Address')} name="address">
              <Input placeholder={t('Full address')} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
